// Avoid `console` errors in browsers that lack a console.
(function() {
    var method;
    var noop = function noop() {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());


// limit the number of times a function can be run within a given time frame
function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

if (typeof(Modernizr) !== 'undefined') {
	Modernizr.addTest('hires', function() {
		// for opera
		var ratio = '2.99/2';
		// for webkit
		var num = '1.499';
		var mqs = [
			'only screen and (min-resolution: 192dpi)',
			'only screen and (min-resolution: 1.5dppx)',
			'only screen and (-o-min-device-pixel-ratio:' + ratio + ')',
			'only screen and (min--moz-device-pixel-ratio:' + num + ')',
			'only screen and (-webkit-min-device-pixel-ratio:' + num + ')',
			'only screen and (min-device-pixel-ratio:' + num + ')'
		];
		var isHighRes = false;

		// loop through vendors, checking non-prefixed first
		for (var i = mqs.length - 1; i >= 0; i--) {
			isHighRes = Modernizr.mq( mqs[i] );
			// if found one, return early
			if ( isHighRes ) {
				return isHighRes;
			}
		}
		// not highres
		return isHighRes;
	});
}

function getURLParameter(name) {
    return decodeURIComponent( (RegExp(name + '=' + '(.+?)(&|$)').exec(location.search)||[,""])[1] );
    //return decodeURI( (RegExp(name + '=' + '(.+?)(&|$)').exec(location.search)||[,null])[1] );
}
